import { Button } from '@qr-front/ui/components/Button'
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogTitle,
} from '@qr-front/ui/components/Dialog'
import { useTranslations } from 'next-intl'

export const PromptDialog = ({
	isOpen,
	setIsOpen,
	onConfirm,
}: {
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onConfirm: () => void
}) => {
	const t = useTranslations()

	return (
		<Dialog open={isOpen} onOpenChange={setIsOpen}>
			<DialogContent closeButtonLabel={t('ui__popup__close_button')}>
				<DialogTitle className="text-center">
					{t('generator__address_change_prompt_dialog__title')}
				</DialogTitle>
				<DialogDescription className="mt-2 text-center">
					{t('generator__address_change_prompt_dialog__description')}
				</DialogDescription>
				<DialogFooter className="mt-6">
					<Button
						visual="secondary"
						size="large"
						onClick={() => {
							setIsOpen(false)
						}}
					>
						{t('generator__address_change_prompt_dialog__no')}
					</Button>
					<Button
						size="large"
						onClick={() => {
							setIsOpen(false)
							onConfirm()
						}}
					>
						{t('generator__address_change_prompt_dialog__yes')}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	)
}
